import axios from 'axios'
import { BASE_URL } from '@/environment/environment'
import { onboardingEntityApiUrl } from '@/modules/onboarding/utils/demoApi'

export type QuestionnaireValue = string | Record<string, string>[] | null

export interface QuestionnaireQuestion {
  id: number
  code: string
  label: string
  field_type: 'choice' | 'text' | 'date' | 'planned_date' | 'table'
  options: { value: string; label: string }[]
  show_if: { question: string; values: string[] } | Record<string, never>
  help_text: string
}
export interface QuestionnaireAssessment {
  suggested_result: string | null
  reason: string
  confirmed_result: string | null
  explanation: string
  confirmed_at: string | null
  needs_confirmation: boolean
}
export interface QuestionnaireEntry {
  participant: string | null
  action?: string
  subject?: string
  action_status?: string
  answers: Record<string, QuestionnaireValue>
  visible_questions: string[]
  assessment: QuestionnaireAssessment | null
}
export interface QuestionnaireSection {
  id: number
  code: string
  name: string
  scope: 'event' | 'patient' | 'action'
  allow_without_patient: boolean
  assessment_code: string
  assessment_title?: string
  assessment_label?: string
  assessment_options?: string[]
  questions: QuestionnaireQuestion[]
  entries: QuestionnaireEntry[]
}
export interface QuestionnaireState {
  token: string
  can_edit: boolean
  event_type: string
  sections: QuestionnaireSection[]
  available_questionnaires?: { id: number; name: string }[]
}
export interface QuestionnaireAnswer {
  question: number
  participant: string | null
  action?: string
  value: QuestionnaireValue
}
export interface QuestionnaireConfirmation {
  questionnaire: number
  participant: string | null
  grade: string
  explanation: string
}
const url = (id: number) => `${BASE_URL}/api/adverse/adverse-event/${id}/questionnaires/`
export const questionnairesApi = {
  async get(id: number): Promise<QuestionnaireState> {
    return (await axios.get(onboardingEntityApiUrl('adverse_event', id, `/adverse/adverse-event/${id}/questionnaires/`))).data
  },
  async add(id: number, token: string, questionnaire: number): Promise<QuestionnaireState> {
    return (await axios.post(`${url(id)}add/`, { token, questionnaire })).data
  },
  async preview(id: number, token: string, answers: QuestionnaireAnswer[]): Promise<QuestionnaireState> {
    return (await axios.post(url(id), { token, answers })).data
  },
  async save(id: number, token: string, answers: QuestionnaireAnswer[], confirmation?: QuestionnaireConfirmation): Promise<QuestionnaireState> {
    return (await axios.patch(url(id), { token, answers, confirmation })).data
  },
  async options(): Promise<{ id: number; name: string }[]> {
    return (await axios.get(`${BASE_URL}/api/adverse/adverse-event-type/questionnaire-options/`)).data
  },
}
